var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { List } from 'immutable';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { transformBetSlip, createBetModel, getSelectedFreebet } from '../utils';
import * as BetTypeMap from '../../../constants/BetType';
import * as BetStatus from '../../../constants/BetStatus';
import { resourceAmount, resourceNames } from '../../../constants/accountResourceNames';
import { makeQuickBet as makeBetAction } from '../../../actions/creators/makeBet';
import { cancelBigStakeRequest as cancelBigStakeRequestAction } from '../../../actions/creators/BigStakeRequest';
import { addRateCoupon as addRateCouponAction, changeBetAmount as changeBetAmountAction } from '../../../actions/coupon/creators/coupon';
import { openAuthModal as openAuthModalAction } from '../../../actions/auth/creators/Login';
import { getFreebet as getFreebetAction } from '../../../actions/auth/creators/SignIn';
import { acceptChange as acceptChangeAction } from '../../../actions/coupon/creators/quickbet';
import FreebetButton from '../FreebetButton';
import Event from './Event';
import Error from './QuickBetError';
import QuickBetSuccess from './QuickBetSuccess';
import StakeVariants from '../StakeVariants';
import { defineMessages, FormattedMessage, injectIntl, FormattedHTMLMessage } from 'react-intl';
import { isRateUnavailable } from '../rateUtils';
import { minAmount as MinAmountValues } from '../../../constants/StakeMinAmount';
import { maxWinAmount as MaxBetAmountValues } from '../../../constants/StakeMaxWinAmount';
import { resourceNames as resources } from '../../../constants/accountResourceNames';
import _Input from './../betTypesComponents/_Input';
import Swipeable from 'react-swipeable';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import UnavailableRate from '../UnavailableRate';
import localeMap from '../../../constants/Locale';
var messages = defineMessages({
    coupon_clear: {
        id: 'coupon.clear',
        defaultMessage: '<span class="button__hint-top">нажмите еще раз чтобы</span><span class="button__hint-bottom">Clear</span>'
    },
    bets_potential_return: {
        id: 'bets.potential_return',
        defaultMessage: 'Возможный выигрыш:'
    },
    coupon_stake_amount: {
        id: 'coupon.stake_amount',
        defaultMessage: 'Сумма ставки'
    },
    coupon_coefficient_changed: {
        id: 'coupon.coefficient_changed',
        defaultMessage: 'Odd has changed!'
    },
    coupon_accept_changes: {
        id: 'coupon.accept_changes',
        defaultMessage: 'Accept Changes'
    },
    coupon_cancel_big_bet: {
        id: 'coupon.cancel_big_bet',
        defaultMessage: 'Cancel big stake'
    },
    coupon_make_bet: {
        id: 'coupon.make_bet',
        defaultMessage: 'Place Bet'
    },
    coupon_make_bet_stake: {
        id: 'coupon.make_bet_stake',
        defaultMessage: 'ставку',
    },
    coupon_your_balance: {
        id: 'coupon.your_balance',
        defaultMessage: 'Your Balance'
    },
    coupon_add_to_coupon: {
        id: 'coupon.add_to_coupon',
        defaultMessage: 'Add to Bet Slip'
    },
    enter_bet_amount: {
        id: 'coupon.enter_bet_amount',
        defaultMessage: 'Введите сумму ставки!',
    }
});
function createFactorsModel(quickBet) {
    var betMap = quickBet.get('bet');
    var bet = betMap.get(betMap.keySeq().first());
    return new List().push(transformBetSlip(bet));
}
var QuickBet = /** @class */ (function (_super) {
    __extends(QuickBet, _super);
    function QuickBet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            active: false,
            showSuccessModal: true,
            freebetToggled: false,
            selectedFreebetId: undefined
        };
        _this.targetElement = null;
        _this.makeBet = function (makeBetAction, amount, user, isFreebet, factors, bettingMode, freebetId) {
            if (isFreebet === void 0) { isFreebet = false; }
            if (amount <= 0) {
                alert(_this.props.intl.formatMessage(messages.enter_bet_amount));
                return false;
            }
            var lang = localeMap[_this.props.languageId];
            makeBetAction(createBetModel(amount, user, BetTypeMap.SINGLE, null, isFreebet, factors, bettingMode, lang, freebetId));
        };
        _this.addCouponRate = function () {
            var quickBet = _this.props.quickBet;
            var betMap = quickBet.get('bet');
            var bet = betMap.get(betMap.keySeq().first());
            _this.props.addRateCouponAction(bet);
            _this.props.close();
        };
        _this.closeSuccessModal = function () {
            _this.setState({
                showSuccessModal: false
            });
            _this.props.close();
            _this.props.getFreebetAction();
        };
        _this.makeFreebetClick = function (e) {
            e.preventDefault();
            var _a = _this.props, quickBet = _a.quickBet, user = _a.user, freebets = _a.freebets, bettingMode = _a.bettingMode;
            var freebet = getSelectedFreebet(freebets, _this.state.selectedFreebetId);
            _this.makeBet(_this.props.makeBetAction, freebet.amount, user, true, createFactorsModel(quickBet), bettingMode, freebet.id);
        };
        _this.makeBetClick = function (e) {
            e.preventDefault();
            var _a = _this.props, couponAmount = _a.couponAmount, quickBet = _a.quickBet, user = _a.user, bettingMode = _a.bettingMode;
            var status = quickBet.get('status');
            var isBigStake = status === BetStatus.STAKE_REQUEST;
            var savedCouponAmount = couponAmount > 0 ? couponAmount : Number(localStorage.getItem('couponAmountValue'));
            if (!isBigStake) {
                _this.makeBet(_this.props.makeBetAction, savedCouponAmount, user, false, createFactorsModel(quickBet), bettingMode);
            }
        };
        _this.acceptFactorChanged = function () {
            _this.props.acceptChangeAction();
        };
        _this.changeBetAmount = function (e) {
            if (!_this.state.freebetToggled) {
                _this.setState({
                    amountError: false,
                    freebetToggled: false
                });
                _this.props.changeBetAmountAction(e.target.value.replace(/\D/g, ''));
            }
        };
        _this.toggleFreebet = function () {
            _this.setState({
                freebetToggled: !_this.state.freebetToggled
            });
        };
        _this.onCancelBigStakeRequest = function () {
            var _a = _this.props, user = _a.user, quickBet = _a.quickBet;
            var gamblerId = user.gamblerId;
            var stakeId = quickBet.get('stakeId');
            _this.props.cancelBigStakeRequestAction({ gamblerId: gamblerId, stakeId: stakeId });
        };
        _this.onEventClick = function () {
            _this.setState({
                active: !_this.state.active
            });
        };
        _this.onLongSwipe = function (e, absX) {
            if (absX !== 0) {
                _this.setState({
                    active: true
                });
            }
        };
        _this.onSwipeRight = function () {
            _this.setState({
                active: false
            });
        };
        _this.closeModal = function () {
            var quickBet = _this.props.quickBet;
            var loading = quickBet.get('loading');
            var status = quickBet.get('status');
            var isBigStake = status === BetStatus.STAKE_REQUEST;
            var isLoading = loading || status === BetStatus.CONFIRM_AWAIT || status === BetStatus.IN_DELAY;
            if (isBigStake) {
                isLoading = true;
            }
            if (isLoading === false) {
                _this.props.close();
            }
        };
        _this.addBtnHandler = function (couponAmountValue, amount) {
            _this.props.changeBetAmountAction(+couponAmountValue + amount);
        };
        _this.subtractBtnHandler = function (couponAmountValue, amount) {
            if (+couponAmountValue >= amount) {
                _this.props.changeBetAmountAction(+couponAmountValue - amount);
            }
        };
        return _this;
    }
    QuickBet.prototype.componentDidMount = function () {
        var user = this.props.user;
        this.targetElement = document.querySelector('#new-quickbet');
        disableBodyScroll(this.targetElement);
        if (this.props.bettingMode.isOneClickOn && user && user.accountId) {
            var _a = this.props, quickBet = _a.quickBet, user_1 = _a.user, bettingMode = _a.bettingMode;
            var status = quickBet.get('status');
            var isBigStake = status === BetStatus.STAKE_REQUEST;
            if (!isBigStake) {
                this.makeBet(this.props.makeBetAction, bettingMode.oneClickAmount, user_1, false, createFactorsModel(quickBet), bettingMode);
            }
        }
    };
    QuickBet.prototype.componentDidUpdate = function (prevProps) {
        var user = this.props.user;
        if (user !== prevProps.user && user && user.accountId && this.props.bettingMode.isOneClickOn) {
            var _a = this.props, quickBet = _a.quickBet, bettingMode = _a.bettingMode;
            var status = quickBet.get('status');
            var isBigStake = status === BetStatus.STAKE_REQUEST;
            if (!isBigStake) {
                this.makeBet(this.props.makeBetAction, bettingMode.oneClickAmount, user, false, createFactorsModel(quickBet), bettingMode);
            }
        }
    };
    QuickBet.prototype.componentWillUnmount = function () {
        clearAllBodyScrollLocks();
    };
    QuickBet.prototype.renderControls = function (bettingAvailable, factorChanged, actualValue, unavailable, isBigStake, freebetToggled, btnDisabled, isAuthenticated) {
        var submitBtnCls = bettingAvailable ? 'singlebet_submit' : 'singlebet_submit betting-unavailable';
        if (!isAuthenticated) {
            return (_jsx("div", __assign({ className: 'make-stake-control controls' }, { children: _jsx("button", __assign({ className: 'singlebet_submit', onClick: this.props.openAuthModalAction }, { children: _jsx(FormattedMessage, __assign({}, messages.coupon_make_bet, { values: { title: this.props.intl.formatMessage(messages.coupon_make_bet_stake) } })) })) })));
        }
        if (!isBigStake && factorChanged && actualValue) {
            return (_jsx("div", __assign({ className: 'controls accepted' }, { children: _jsx("button", __assign({ type: 'button', id: 'acceptchanges', onClick: this.acceptFactorChanged }, { children: _jsx(FormattedMessage, __assign({}, messages.coupon_accept_changes)) })) })));
        }
        if (unavailable) {
            return false;
        }
        if (isBigStake) {
            return (_jsxs("div", __assign({ className: 'controls cancel_big_stake', onClick: this.onCancelBigStakeRequest }, { children: [_jsx("button", { className: 'loading' }), _jsx("div", __assign({ style: { marginTop: '2px', cursor: 'pointer' } }, { children: _jsx(FormattedMessage, __assign({}, messages.coupon_cancel_big_bet)) }))] })));
        }
        var click = freebetToggled ? this.makeFreebetClick : this.makeBetClick;
        var loadingCls = btnDisabled ? 'loading' : '';
        if (isBigStake) {
            loadingCls = ' loading';
        }
        return (_jsx("div", __assign({ className: 'make-stake-control controls' }, { children: _jsx("button", __assign({ className: "".concat(submitBtnCls, " ").concat(loadingCls), onClick: click, disabled: btnDisabled }, { children: _jsx(FormattedMessage, __assign({}, messages.coupon_make_bet, { values: { title: this.props.intl.formatMessage(messages.coupon_make_bet_stake) } })) })) })));
    };
    ;
    QuickBet.prototype.render = function () {
        var _this = this;
        var _a = this.props, close = _a.close, quickBet = _a.quickBet, gridLocalization = _a.gridLocalization, couponAmount = _a.couponAmount, user = _a.user, freebets = _a.freebets, intl = _a.intl, client = _a.client;
        var _b = this.state, freebetToggled = _b.freebetToggled, active = _b.active, selectedFreebetId = _b.selectedFreebetId;
        var freebet = getSelectedFreebet(freebets, selectedFreebetId);
        var loading = quickBet.get('loading');
        var status = quickBet.get('status');
        var betMap = quickBet.get('bet');
        var bet = betMap.get(betMap.keySeq().first());
        var rate = bet.get('rate');
        var factorChanged = bet.get('factorChanged');
        var unavailable = bet.get('unavailable');
        var value = rate.get('value');
        var actualValue = rate.get('actualValue');
        var errorCode = quickBet.get('betCreateError');
        var alternativeStake = quickBet.get('alternativeStake');
        var freebetErrors = quickBet.get('freebetErrors');
        var accountResourceId = user.accountResourceId;
        var isBigStake = status === BetStatus.STAKE_REQUEST;
        var accountResourceName = resourceNames[accountResourceId];
        var isOneClick = this.props.bettingMode.isOneClickOn && user && user.accountId;
        var bettingAvailable = true;
        if (status === BetStatus.CONFIRMED) {
            return _jsx(QuickBetSuccess, { closeModal: this.closeSuccessModal, show: true, isOneClick: isOneClick });
        }
        var couponAmountValue = freebetToggled ? freebet.amount : couponAmount;
        var possibleWinAmount = couponAmountValue * value;
        if (factorChanged && actualValue) {
            possibleWinAmount = couponAmountValue * actualValue;
        }
        var itemCls = 'item';
        if (isRateUnavailable(rate)) {
            itemCls += ' disable';
            bettingAvailable = false;
        }
        var showError = '';
        if (errorCode !== undefined || status === BetStatus.REJECTED) {
            var errorProps = {
                user: user,
                errorCode: errorCode,
                alternativeStake: alternativeStake,
                accountResourceId: user.accountResourceId,
                resolution: quickBet.get('resolution'),
                limit: quickBet.get('limit') || 0
            };
            showError = _jsx(Error, __assign({}, errorProps));
        }
        if (couponAmount > this.props.balance && user && user.accountId) {
            var errorProps = {
                errorCode: 111,
                user: user,
            };
            bettingAvailable = false;
            showError = _jsx(Error, __assign({}, errorProps));
        }
        if (couponAmount > 0 && couponAmount < MinAmountValues[resources[user.accountResourceId]]) {
            var errorProps = {
                user: user,
                errorCode: 6,
                accountResourceId: user.accountResourceId,
                resolution: quickBet.get('resolution'),
                minBetAmount: MinAmountValues[resources[user.accountResourceId]]
            };
            bettingAvailable = false;
            showError = _jsx(Error, __assign({}, errorProps));
        }
        if (possibleWinAmount > MaxBetAmountValues[resources[user.accountResourceId]]) {
            var errorProps = {
                user: user,
                errorCode: 7,
                accountResourceId: user.accountResourceId,
                resolution: quickBet.get('resolution'),
                maxWinAmount: MaxBetAmountValues[resources[user.accountResourceId]]
            };
            bettingAvailable = false;
            showError = _jsx(Error, __assign({}, errorProps));
        }
        if (freebetErrors) {
            var errorProps = {
                user: user,
                freebetErrors: freebetErrors,
                accountResourceId: user.accountResourceId,
                resolution: quickBet.get('resolution'),
            };
            bettingAvailable = false;
            showError = _jsx(Error, __assign({}, errorProps));
        }
        var eventProps = {
            active: active,
            close: close,
            onEventClick: this.onEventClick,
            bet: bet,
            gridLocalization: gridLocalization,
            changeBetAmount: this.changeBetAmount,
            couponAmount: couponAmount,
            isBigStake: isBigStake,
            user: user,
            accountResourceName: accountResourceName,
            possibleWinAmount: possibleWinAmount,
        };
        var freebetProps = {
            freebetToggled: freebetToggled,
            freebets: freebets,
            selectedFreebetId: freebet.id,
            selectFreebet: function (id) { return _this.setState({ selectedFreebetId: id }); },
            accountResourceName: accountResourceName,
            toggleFreebet: this.toggleFreebet
        };
        var currency = resourceNames[user.accountResourceId];
        var amount = resourceAmount[user.accountResourceId];
        var isAuthenticated = user.accountResourceId !== undefined;
        if (user.accountResourceId === undefined) {
            bettingAvailable = false;
        }
        var btnDisabled = loading || status === BetStatus.CONFIRM_AWAIT || status === BetStatus.IN_DELAY;
        var modalContentCls = btnDisabled ? ' modal-is-loading' : '';
        var darkTheme = this.props.darkTheme;
        var clearSvgName = darkTheme ? 'dark-clear-betslip.svg' : 'clear-betslip.svg';
        var addSvgName = darkTheme ? 'dark-add.svg' : 'add.svg';
        if (amount === undefined) {
            amount = client.country === 'KG' ? 10 : 100;
        }
        var possibleWin = (Math.trunc(possibleWinAmount * 1000) / 1000);
        var couponContent = (_jsxs("div", __assign({ className: 'new-betslips__coupon' }, { children: [_jsx("div", __assign({ className: 'items' }, { children: _jsx("div", __assign({ className: itemCls }, { children: _jsx(Swipeable, __assign({ onSwipingRight: this.onSwipeRight, onSwipedLeft: this.onLongSwipe }, { children: _jsx(Event, __assign({}, eventProps)) })) })) })), _jsxs("div", __assign({ className: 'add' }, { children: [_jsxs("span", __assign({ className: 'stake-label' }, { children: [_jsx(FormattedMessage, __assign({}, messages.bets_potential_return)), _jsxs("span", { children: [_jsx("span", __assign({ className: 'possible-win-amount' }, { children: possibleWin ? possibleWin.toFixed(2) : possibleWin })), " ", currency] })] })), _jsxs("div", __assign({ className: 'control' }, { children: [_jsxs("span", { children: [_jsx("button", { className: 'subtract-btn', onClick: function () { return _this.subtractBtnHandler(couponAmount, amount); } }), _jsx(_Input, { changeAmount: this.changeBetAmount, freebetToggled: freebetToggled, couponAmount: couponAmount, placeholder: intl.formatMessage(messages.coupon_stake_amount) }), _jsx("button", { className: 'add-btn', onClick: function () { return _this.addBtnHandler(couponAmount, amount); } })] }), !isBigStake && showError] }))] })), _jsx(StakeVariants, { freebetToggled: freebetToggled }), freebets.length > 0 && _jsx(FreebetButton, __assign({}, freebetProps)), this.renderControls(bettingAvailable, factorChanged, actualValue, unavailable, isBigStake, freebetToggled, btnDisabled, isAuthenticated, this.props.openAuthModalAction), !isBigStake &&
                    _jsxs("div", __assign({ className: 'coupon__controls' }, { children: [_jsxs("button", __assign({ onClick: close, className: 'clear-btn clear-btn--first', style: { top: '-2px' } }, { children: [_jsx("img", { src: require("./../../../assets/img/".concat(clearSvgName)), alt: '' }), _jsx(FormattedHTMLMessage, __assign({}, messages.coupon_clear))] })), !unavailable && _jsxs("button", __assign({ onClick: this.addCouponRate }, { children: [_jsx("img", { src: require("./../../../assets/img/".concat(addSvgName)), alt: '' }), _jsx(FormattedMessage, __assign({}, messages.coupon_add_to_coupon))] }))] }))] })));
        if (isOneClick) {
            var showErrorIcon = showError !== '';
            var oneClickContent = (_jsxs("div", { children: [!showErrorIcon && _jsx("div", __assign({ className: 'controls' }, { children: _jsx("button", { className: 'singlebet_submit loading' }) })), !isBigStake && showError] }));
            if (isBigStake && status !== BetStatus.REJECTED) {
                oneClickContent = (_jsxs("div", __assign({ className: 'controls cancel_big_stake', onClick: this.onCancelBigStakeRequest, style: { marginBottom: '15px' } }, { children: [_jsx("button", { className: 'loading' }), _jsx("div", __assign({ style: { marginTop: '2px', cursor: 'pointer' } }, { children: _jsx(FormattedMessage, __assign({}, messages.coupon_cancel_big_bet)) }))] })));
            }
            couponContent = (_jsx(UnavailableRate, __assign({ close: this.props.close, unavailable: unavailable, showErrorIcon: showErrorIcon, errorCode: errorCode }, { children: oneClickContent })));
        }
        var oneClickModalContentCls = isOneClick ? 'one-click' : '';
        return (_jsxs("div", __assign({ className: 'new-betslips active quickbet', id: 'new-quickbet' }, { children: [_jsx("div", { className: 'new-betslips__overlay' }), _jsx("div", __assign({ className: "new-betslips__content".concat(modalContentCls, " ").concat(oneClickModalContentCls) }, { children: couponContent }))] })));
    };
    return QuickBet;
}(React.Component));
QuickBet.propTypes = {
    close: PropTypes.func.isRequired,
    cancelBigStakeRequestAction: PropTypes.func.isRequired,
    quickbetModalToggled: PropTypes.bool.isRequired,
    quickBet: PropTypes.object.isRequired,
    couponAmount: PropTypes.any.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    bettingMode: PropTypes.object.isRequired,
    addRateCouponAction: PropTypes.func.isRequired,
    changeBetAmountAction: PropTypes.func.isRequired,
    makeBetAction: PropTypes.func.isRequired,
    acceptChangeAction: PropTypes.func.isRequired,
    openAuthModalAction: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    balance: PropTypes.number.isRequired,
    freebets: PropTypes.array.isRequired,
    intl: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired,
};
var mapStateToProps = function (state) { return ({
    quickBet: state.coupon.get('quickBet'),
    couponAmount: state.coupon.get('couponAmount'),
    user: state.auth.user,
    freebets: state.auth.freebets,
    balance: state.balance.value,
    bettingMode: state.application.get('bettingMode'),
    darkTheme: state.application.get('darkTheme'),
    client: state.application.get('client'),
    languageId: state.application.get('languageId')
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    addRateCouponAction: addRateCouponAction,
    changeBetAmountAction: changeBetAmountAction,
    makeBetAction: makeBetAction,
    acceptChangeAction: acceptChangeAction,
    getFreebetAction: getFreebetAction,
    cancelBigStakeRequestAction: cancelBigStakeRequestAction,
    openAuthModalAction: openAuthModalAction,
}, dispatch); };
QuickBet = connect(mapStateToProps, mapDispatchToProps)(QuickBet);
export default injectIntl(QuickBet);



// WEBPACK FOOTER //
// ./src/components/coupon/quickbet/QuickBet.jsx